import { render, staticRenderFns } from "./Meja.vue?vue&type=template&id=fb9e76a0&"
import script from "./Meja.vue?vue&type=script&lang=js&"
export * from "./Meja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports